import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { map, catchError, switchMap } from 'rxjs/operators';
import { FeeQuoteService } from './api/fee-quote.api';
import {
  ClearFeeQuoteAction,
  FeeQuoteActions,
  GetFeeQuoteFailedAction,
  GetFeeQuoteSucessAction,
  GetFxRateFailedAction,
  GetFxRateSuccessAction,
} from './fee-quote.actions';

@Injectable()
export class FeeQuoteEffects {
  feeQuote$: Observable<any> = createEffect(() =>
    this.actions$.pipe(
      ofType(FeeQuoteActions.GET_FEE_QUOTE),
      switchMap(({ feeLookupRequest, endpoint, operation }) =>
        this.feeQuoteService.getFeeQuote(feeLookupRequest, endpoint, operation).pipe(
          map((data) => {
            this.store.dispatch(ClearFeeQuoteAction());
            return GetFeeQuoteSucessAction({ feeLookupResponse: data });
          }),
          catchError((error) => of(GetFeeQuoteFailedAction({ error })))
        )
      )
    )
  );

  fxRate$: Observable<any> = createEffect(() =>
    this.actions$.pipe(
      ofType(FeeQuoteActions.GET_FX_RATE),
      switchMap(({ fxRequest, endpoint }) =>
        this.feeQuoteService.getFxRate(fxRequest, endpoint).pipe(
          map((data) => {
            return GetFxRateSuccessAction({ fxRateResponse: data });
          }),
          catchError((error) => of(GetFxRateFailedAction({ error })))
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private feeQuoteService: FeeQuoteService,
    private store: Store
  ) {}
}
